// External Imports
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Alert from 'react-bootstrap/Alert';
import AccessDenied from './AccessDenied';

export default function Alerts({ alerts }) {
  return (
    <>
      {alerts.map((alert) => (
        <Fragment key={alert.id}>
          {alert.access_denied ? (
            <AccessDenied />
          ) : (
            <Alert variant={alert.severity}>
              <span>{alert.message}</span>
            </Alert>
          )}
        </Fragment>
      ))}
    </>
  );
}

Alerts.propTypes = {
  alerts: PropTypes.array,
};
